var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM30.7 35.1624V32.6999C30.7 31.3937 30.1812 30.141 29.2575 29.2174C28.3339 28.2938 27.0812 27.7749 25.775 27.7749H15.925C14.6188 27.7749 13.3661 28.2938 12.4425 29.2174C11.5189 30.141 11 31.3937 11 32.6999V35.1624H30.7ZM25.7753 17.925C25.7753 20.645 23.5703 22.85 20.8503 22.85C18.1303 22.85 15.9253 20.645 15.9253 17.925C15.9253 15.205 18.1303 13 20.8503 13C23.5703 13 25.7753 15.205 25.7753 17.925ZM34.5558 35V32.5559C34.5558 31.2593 34.0407 30.0158 33.1238 29.0989C33.0903 29.0654 33.0564 29.0324 33.022 29H34C35.0609 29 36.0783 29.4214 36.8285 30.1716C37.5786 30.9217 38 31.9391 38 33V35H34.5558ZM29.7776 18.8889C29.7776 20.913 28.5476 22.6498 26.7942 23.3925C27.5236 24.3683 28.6881 25 30.0001 25C32.2092 25 34.0001 23.2091 34.0001 21C34.0001 18.7909 32.2092 17 30.0001 17C29.802 17 29.6072 17.0144 29.4168 17.0422C29.6494 17.612 29.7776 18.2355 29.7776 18.8889Z",
    fill: "#C9CCD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c0f3aaf2cc944427f9fd81b656b9b8a8.svg";
export { ForwardRef as ReactComponent };